import { Component } from '@angular/core';

@Component({
  selector: 'app-user-profile-preference',
  templateUrl: './user-profile-preference.component.html',
  styleUrls: ['./user-profile-preference.component.scss'],
})
export class UserProfilePreferenceComponent {
  usersPrefBreadcrumbs: any = [
    {
      label: 'Users',
      link: '/auth0/admin/users',
      active: false,
    },
    {
      label: 'Profile & Preference',
      active: true,
    },
  ];
}
